import { makeStyles } from '@mui/styles'

export const styles = makeStyles(() => ({
  root: {
    width: '95%',
    padding: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiInputBase-root': {
      '& input[type=search]': {
        width: '17vw',
        minWidth: '280px',
      },
    },
  },

  leftWrapper: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
  },

  rightWrapper: {
    display: 'flex',
    gap: '1rem',
    width: 'fit-content',
    alignItems: 'center',
    margin: '0 1.5rem',
  },
  
  filterStatus: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  select: {
    width: '130px',
  },
  
}))
